/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleShiftState.js'
import mutations from './moduleShiftMutations.js'
import actions from './moduleShiftActions.js'
import getters from './moduleShiftGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
